import { X, Warning } from '@phosphor-icons/react'
import { useState } from 'react'
import { supabase } from '../lib/supabase'
import toast from 'react-hot-toast'

export default function DeleteEventModal({ isOpen, onClose, event, onSuccess }) {
  const [loading, setLoading] = useState(false)

  if (!isOpen || !event) return null

  const handleDelete = async () => {
    setLoading(true)
    
    try {
      // Delete related records first
      const { error: confirmError } = await supabase
        .from('event_confirmations')
        .delete()
        .eq('event_id', event.id)
      
      if (confirmError) throw confirmError

      const { error: attendanceError } = await supabase
        .from('attendance_records')
        .delete()
        .eq('event_id', event.id)
      
      if (attendanceError) throw attendanceError

      // Delete the event
      const { error: eventError } = await supabase
        .from('events')
        .delete()
        .eq('id', event.id)
      
      if (eventError) throw eventError

      toast.success('Event deleted successfully')
      onSuccess()
      onClose()
    } catch (error) {
      console.error('Delete error:', error)
      toast.error('Failed to delete event')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose} />
      
      {/* Modal */}
      <div className="relative bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 p-6">
        {/* Close Button */}
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 p-1 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <X size={20} />
        </button>

        {/* Warning Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <Warning size={32} className="text-red-600" weight="fill" />
          </div>
        </div>

        {/* Content */}
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Delete Event?</h2>
          <p className="text-gray-600 mb-1">
            Are you sure you want to delete this event?
          </p>
          <p className="text-sm text-gray-600 font-regular mt-2">
            This will also delete all attendance records and confirmations for this event.
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-3">
          <button 
            onClick={onClose} 
            disabled={loading}
            className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Cancel
          </button>
          <button 
            onClick={handleDelete} 
            disabled={loading}
            className="flex-1 px-4 py-3 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  )
}